import * as React from 'react';
import * as w from '@packages/systems/wfdl';
import {FinePrint} from '@packages/systems/design-system/Text';
import {styled, styledDiv} from '@packages/utilities/styled';
import {
  ExpressionEditor,
  extendExpressionEditorActionAtPath,
} from '@packages/systems/ExpressionEditor-utils';
import {LogicLabel} from '@packages/systems/flows/shared';
import {TNonEmptyText} from '@packages/systems/plugins/Text';
import {ContextualExpressions} from '@packages/utilities/contextual-expression';

const GridWrapper = styledDiv(({theme: {gutters}}) => ({
  display: 'grid',
  gridAutoColumns: 'minmax(0, auto)',
  gridRowGap: gutters.x4,
}));

const StyledFinePrint = styled(FinePrint)(({theme: {colors}}) => ({
  color: colors.logicFlows.foregroundDimAlt,
  marginBottom: '2px',
}));

const UrlType = w.withSystem(
  {label: 'URL'},
  w.withMeta({placeholder: 'Enter link...'}, TNonEmptyText)
);

const urlPath = [{in: 'Record', at: 'URL'}] satisfies w.ExpressionPath;

export const RequestURLType = w.TypeImplementation.Alias({
  type: UrlType,
  render: function RenderRequestURL({expr, dispatch}) {
    const URL = ContextualExpressions.getIn(expr, urlPath);

    if (URL == null) {
      return <ExpressionEditor dispatch={dispatch} expression={expr} />;
    }

    return (
      <GridWrapper data-automation-id="ExpressionEditor-fieldWrapper-URL">
        <LogicLabel label="URL" required>
          <StyledFinePrint>Add the URL for the service.</StyledFinePrint>
          <ExpressionEditor
            dispatch={extendExpressionEditorActionAtPath(dispatch)(urlPath)}
            expression={URL}
          />
        </LogicLabel>
      </GridWrapper>
    );
  },
});
